<div class="row" id="tenants">
  <!-- Product Edition field -->
  <mat-form-field appearance="outline" style="width: 400px">
    <mat-label>{{ 'Filter by Product Edition' | translate: locale.language }}</mat-label>
    <mat-select (selectionChange)="onProductFilterChange($event.value)" [formControl]="productControl">
      <mat-option>{{ 'All (not filtered)' | translate: locale.language }}</mat-option>
      @for (product of productEditions(); track product) {
        <mat-option [value]="product">{{ product }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Search field -->
  <mat-form-field style="width: 100%" appearance="outline">
    <mat-label for="qa-search-tenants">{{ 'Search by Tenant Name' | translate: locale.language }}</mat-label>
    <input matInput type="any" id="qa-search-tenants" [formControl]="searchControl" [matAutocomplete]="autoGroup" />
    @if (searchControl.dirty) {
      <button
        matIconSuffix
        mat-icon-button
        [attr.aria-label]="'Clear' | translate: locale.language"
        (click)="onResetSearch()">
        @if (searchInProgress()) {
          <mat-spinner diameter="14" class="search-spinner"></mat-spinner>
        } @else {
          <mat-icon>close</mat-icon>
        }
      </button>
    }
    <mat-autocomplete #autoGroup="matAutocomplete">
      @for (result of searchResults(); track $index) {
        <mat-option
          (click)="onAutoComplete(result)"
          [attr.data-test]="'search-result-option-' + $index"
          (keydown.enter)="onAutoComplete(result)"
          >{{ result.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <!-- Paste Tenant IDs field -->
  <div style="margin-bottom: 16px">
    <mat-form-field style="width: 70%" appearance="outline">
      <mat-label>Paste Tenant IDs (comma, space, or newline separated)</mat-label>
      <textarea matInput [formControl]="pasteControl" rows="2" placeholder="e.g. 123, 456, 789&#10;or one per line">
      </textarea>
    </mat-form-field>
    <button
      mat-raised-button
      color="primary"
      style="margin-left: 8px"
      (click)="onPasteTenantIds()"
      [disabled]="!pasteControl.value?.trim()">
      Select Tenants
    </button>
  </div>

  <!-- available tenants -->
  <div class="col m12 l6" id="tenant-selection">
    <h6>Available Tenants:</h6>
    <!-- Loading progress -->
    <div style="width: 100%; min-height: 6px">
      @if (inProgress()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <app-loading [hasLoaded]="true" [hasFailed]="isError()" (retryClicked)="fetchAll()"></app-loading>
    </div>
    <div class="tree-container">
      <mat-tree #tree [dataSource]="treeDataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="32">
          <!-- toggle button for expandle nodes -->
          @if (node.expandable) {
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name" class="node-toggle">
              <mat-icon class="mat-icon-rtl-mirror line-height-75pct">{{
                treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
              }}</mat-icon>
            </button>
          } @else {
            <span style="width: 32px"></span>
          }
          <!-- checkbox for selection -->
          <mat-checkbox
            [checked]="!!node.checked"
            [indeterminate]="!!node.indeterminate"
            [disabled]="!!node.disabled"
            (change)="onSelectedChange(node, $event.checked)"
            class="qa-tenant-node">
            <span [style.font-weight]="!!node.selected ? '500' : 'inherit'" class="qa-tenant-name">
              {{ node.name }}
            </span>
          </mat-checkbox>
        </mat-tree-node>
      </mat-tree>
    </div>
  </div>

  <div class="col s12 l6" id="tenants-selected">
    @if (selectedTotal() > 0) {
      <h6>
        Selected Tenants: <span>{{ selectedTotal() }}</span>
      </h6>
    } @else {
      <h6>Selected Tenants: <span>None Selected</span></h6>
    }
    <div style="margin-top: 24px; padding: 0 4px">
      <mat-chip-listbox aria-label="Selected Tenants">
        @for (item of selectedItems(); track item.key) {
          <mat-chip class="qa-tenant-chip selected chip-text-color-inherit" (removed)="onChipRemove(item)">
            {{ item.name }}
            <button matChipRemove [attr.aria-label]="'Remove ' + item.name" [tabIndex]="0">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        } @empty {
          <mat-chip class="empty" disabled="true" [removable]="false">None Selected</mat-chip>
        }
      </mat-chip-listbox>
    </div>
  </div>
</div>
